const e = {
  undo: "Poništi",
  redo: "Ponovi",
  confirm: "Potvrdi",
  clear: "Čisto",
  more: "više",
  cancel: "Otkazati",
  update: "Ažuriranje"
}, a = {
  positiveText: "Potvrdi",
  negativeText: "Otkazati"
}, t = {
  placeholder: "Molimo izaberite",
  loading: "Učitavam"
}, i = {
  clear: "Čisto",
  now: "Sada",
  confirm: "Potvrdi",
  selectTime: "Odaberite vrijeme",
  selectDate: "Odaberite Datum",
  datePlaceholder: "Odaberite Datum",
  datetimePlaceholder: "Odaberite datum i vrijeme",
  monthPlaceholder: "Odaberite mjesec",
  yearPlaceholder: "Odaberite godinu",
  quarterPlaceholder: "Odaberite Četvrtina",
  startDatePlaceholder: "Početni datum",
  endDatePlaceholder: "Datum završetka",
  startDatetimePlaceholder: "Datum i vrijeme početka",
  endDatetimePlaceholder: "Datum i vrijeme završetka",
  startMonthPlaceholder: "Početni mjesec",
  endMonthPlaceholder: "Kraj mjeseca",
  today: "Danas"
}, o = {
  checkTableAll: "Odaberite sve u tablici",
  uncheckTableAll: "Poništite odabir svih u tablici",
  confirm: "Potvrdi",
  clear: "Čisto",
  apply: "primijeniti",
  filters: "Filteri",
  sort: "Vrsta"
}, r = {
  sourceTitle: "Izvor",
  targetTitle: "Cilj"
}, n = {
  selectAll: "Odaberi sve",
  unselectAll: "Poništi odabir svih",
  clearAll: "Čisto"
}, l = {
  description: "Nema podataka"
}, d = {
  placeholder: "Molimo izaberite"
}, c = {
  placeholder: "Odaberite vrijeme",
  positiveText: "u redu",
  negativeText: "Otkazati",
  now: "Sada"
}, s = {
  goto: "Ići",
  selectionSuffix: "stranica",
  next: "Sljedeći",
  previous: "Prethodno"
}, m = {
  add: "Dodati"
}, u = {
  loading: "Učitavam"
}, p = {
  placeholder: "Molimo unesite"
}, v = {
  placeholder: "Molimo unesite"
}, j = {
  create: "Stvoriti"
}, P = {
  title: "Uređivač tema",
  clearAllVars: "Očisti sve varijable",
  clearSearch: "Očisti pretragu",
  filterCompName: "Naziv komponente filtra",
  filterVarName: "Naziv varijable filtra",
  import: "Uvoz",
  export: "Izvoz",
  restore: "Vrati na zadano"
}, g = {
  tipPrevious: "Prethodna slika (←)",
  tipNext: "Sljedeća slika (→)",
  tipCounterclockwise: "Suprotno od kazaljke na satu",
  tipClockwise: "U smjeru kazaljke na satu",
  tipZoomOut: "Smanji",
  tipZoomIn: "Povećaj",
  tipClose: "Zatvori (Esc)",
  tipOriginalSize: "Zumirajte na izvornu veličinu"
}, h = {
  heading: "Sortiranje i filtriranje",
  sortHeading: "Poredaj po",
  newestFirst: "Prvo najnovije",
  oldestFirst: "Prvo najstariji",
  ascending: "Asc",
  descending: "Desc",
  apply: "primijeniti",
  clear: "Čisto",
  cancel: "Otkazati",
  filters: "Filteri"
}, b = {
  noMatchingFound: "Nisu pronađeni odgovarajući rezultati"
}, k = {
  margin: "Margina",
  padding: "ispune",
  reset: "Poništavanje",
  errorMsg: "Pružena vrijednost nije valjana."
}, D = {
  brandColors: "Boje marke",
  noBrandColors: "Još niste dodali nijednu boju marke.",
  getStarted: "Započni",
  add: "Dodaj",
  default: "Zadano"
}, f = {
  addColor: "Dodaj Novu Boju",
  editColor: "Uredi Boju",
  add: "Dodaj",
  noData: "Još niste dodali nijednu boju.",
  invalidCode: "Nevažeći kod boje",
  defaultColor: "Zadane Boje"
}, T = {
  global: e,
  Popconfirm: a,
  Cascader: t,
  DatePicker: i,
  DataTable: o,
  LegacyTransfer: r,
  Transfer: n,
  Empty: l,
  Select: d,
  TimePicker: c,
  Pagination: s,
  DynamicTags: m,
  Log: u,
  Input: p,
  InputNumber: v,
  DynamicInput: j,
  ThemeEditor: P,
  Image: g,
  SortFilter: h,
  IconPicker: b,
  Spacing: k,
  BrandColorPicker: D,
  BrandBoard: f
};
export {
  f as BrandBoard,
  D as BrandColorPicker,
  t as Cascader,
  o as DataTable,
  i as DatePicker,
  j as DynamicInput,
  m as DynamicTags,
  l as Empty,
  b as IconPicker,
  g as Image,
  p as Input,
  v as InputNumber,
  r as LegacyTransfer,
  u as Log,
  s as Pagination,
  a as Popconfirm,
  d as Select,
  h as SortFilter,
  k as Spacing,
  P as ThemeEditor,
  c as TimePicker,
  n as Transfer,
  T as default,
  e as global
};
